module.exports = __webpack_public_path__ + "statics/img/cate9-3@2x.83e7231e.png";